//  Nguồn: https://dev.to/adrai/how-to-properly-internationalize-a-react-application-using-i18next-3hdb

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { fallbackLanguageCode } from './config/constant'
import STORAGE_KEYS from './constants/localStorage'
import { english } from './locales/en/translation'
import { vietnamese } from './locales/vi/translation'
import { korean } from './locales/ko/translation'
import { japanese } from './locales/ja/translation'
import { chinese } from './locales/zh/translation'
import { indonesian } from './locales/in/translation'
import { malaysia } from './locales/ms/translation'
import { thailand } from './locales/th/translation'
import { taiwanese } from './locales/zh-TW/translation'
import { french } from './locales/fr/translation'

i18n
  // https://github.com/i18next/i18next-http-backend
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem(STORAGE_KEYS.LOCALE) || '',
    fallbackLng: fallbackLanguageCode,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: english,
      vi: vietnamese,
      ko: korean,
      ja: japanese,
      zh: chinese,
      in: indonesian,
      ms: malaysia,
      th: thailand,
      'zh-TW': taiwanese,
      fr: french,
    },
  })

export default i18n
